<template>

    <form ref="empresaparceira-form-desconto" v-on:submit.prevent="executeDesconto(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-6">
                <label for="Nome">Desconto no primeiro estágio</label>
                <input type="text" class="form-control" name="desconto.primeiroEstagioDesconto" placeholder="Desconto no primeiro estágio" v-model="model.desconto.primeiroEstagioDesconto" required />
            </div>

            <div class="form-group col-md-6">
                <label for="Nome">Desconto nos Demais Estágio</label>
                <input type="text" class="form-control" name="desconto.demaisEstagiosDesconto" placeholder="Desconto nos Demais Estágio" v-model="model.desconto.demaisEstagiosDesconto" required />
            </div>

            <div class="form-group col-md-6">
                <label for="Nome">Desconto no Primeiro M.D</label>
                <input type="text" class="form-control" name="desconto.primeiroMaterialDidaticoDesconto" placeholder="Desconto no Primeiro M.D" v-model="model.desconto.primeiroMaterialDidaticoDesconto" required />
            </div>

            <div class="form-group col-md-6">
                <label for="Nome">Desconto nos Demais M.D</label>
                <input type="text" class="form-control" name="desconto.demaisMaterialDidaticoDesconto" placeholder="Desconto nos Demais M.D" v-model="model.desconto.demaisMaterialDidaticoDesconto" required />
            </div>

            <div class="form-group col-md-6">
                <label for="Nome">Data de início</label>
                <input type="text" v-datepicker class="form-control" name="desconto.dataInicioVigencia" placeholder="Data de início" v-model="model.desconto.dataInicioVigencia" required />
            </div>

            <div class="form-group col-md-6">
                <label for="Nome">Data de término</label>
                <input type="text" v-datepicker class="form-control" name="desconto.dataTerminoVigencia" placeholder="Data de término" v-model="model.desconto.dataTerminoVigencia" required />
            </div>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeDesconto(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "empresaparceira-form-desconto",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {
                desconto: {
                }
            },

            form: "empresaparceira-form-desconto",

            resources: {
                edit: 'empresaparceiradesconto',
            },

        }),

        methods: {

            executeDesconto: function (model) {

                if (this.formValidate() == false) return;
                model.empresaParceiraId = this.id;
                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Desconto salvo com sucesso");
                    this.$emit('on-saved', data)
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api(this.resources.edit).get({ empresaParceiraId: this.id }).then(data => {
                if (data.data) this.model = data.data;
                else if (!data.dataList) this.model = {};
                else if (data.dataList.length == 1) this.model = data.dataList[0];
                else this.model =
                    {
                    desconto: {}
                    };
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>